export default __webpack_public_path__ + "static/char-01-2e94cdaa4f11a45635703144d76d06bc.webp";